export class ValidationError {
  public errorCode: string;
  public errorMessage: string;
}



// WEBPACK FOOTER //
// ./src/app/models/validationerror.model.ts